import { render, staticRenderFns } from "./DetalleObservaciones.vue?vue&type=template&id=45245a0c&"
import script from "./DetalleObservaciones.vue?vue&type=script&lang=js&"
export * from "./DetalleObservaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports